import { Briefcase } from 'lucide-react'
import Button from './Button'

const ErrorState = ({error, onRetry}) => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-secondary-50">
        <div className="text-center bg-white p-8 rounded-2xl shadow-lg border">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <Briefcase className="w-8 h-8 text-red-600" />
          </div>
          <p className="text-red-600 mb-6 text-lg">{error}</p>
          <Button onClick={onRetry} variant="primary">
            Try Again
          </Button>
        </div>
      </div>
  )
}

export default ErrorState